import React from 'react';

import { CustomFilterPopover } from '@vlabs/shared/components/filters-panel/components/CustomFilterPopover';
import { Divider } from '@vlabs/uikit';
import { Checkbox } from '@vlabs/uikit/components/controls/checkbox';
import { useTranslation } from 'react-i18next';

import { useEventInfoSettingsLocation } from '../../useEventInfoSettingsSearchParams';

export function EventInfoSettingsPopover(): React.JSX.Element {
  const { t } = useTranslation();
  const { eventInfoSettings, setEventInfoSetting } = useEventInfoSettingsLocation();

  const handleChange = (
    name: 'isVisibleDate' | 'isVisibleSource' | 'isVisibleAddress' | 'isVisibleLists',
  ) => {
    return (event: React.ChangeEvent<HTMLInputElement>) => {
      setEventInfoSetting(name, event.target.checked);
    };
  };

  return (
    <CustomFilterPopover
      placementProp="right-start"
      testId="eventInfoSettings"
      triggerValue={t('lunapoint:настройки.настройки карточки события')}
    >
      <label className="Subtitle-2">
        {t('lunapoint:настройки.показывать в карточках событий')}
      </label>
      <Divider small />

      <Checkbox
        checked={eventInfoSettings.isVisibleDate}
        id="isVisibleDate"
        label={t('дата и время')}
        onChange={handleChange('isVisibleDate')}
      />
      <Divider small />

      <Checkbox
        checked={eventInfoSettings.isVisibleSource}
        id="isVisibleSource"
        label={t('source')}
        onChange={handleChange('isVisibleSource')}

      />
      <Divider small />

      <Checkbox
        checked={eventInfoSettings.isVisibleAddress}
        id="isVisibleAddress"
        label={t('адрес')}
        onChange={handleChange('isVisibleAddress')}
      />
      <Divider small />

      <Checkbox
        checked={eventInfoSettings.isVisibleLists}
        id="isVisibleLists"
        label={t('списки')}
        onChange={handleChange('isVisibleLists')}
      />

    </CustomFilterPopover>
  );
}
